import React from "react";

import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Alert from "@mui/material/Alert";


const StepDefaultSummary = ({requestAutoReplyEnabled}) => {
    return <Stack spacing={2}>
        <Typography variant="body2">
            Cliccando su salva verrà impostato <strong>LivignoItaly</strong> come servizio di invio posta.
        </Typography>
        {requestAutoReplyEnabled === true &&
            <Alert severity="warning">
                Utilizzando LivignoItaly come servizio di invio email verranno disabilitate le risposte automatiche.
            </Alert>}
    </Stack>
}

export default StepDefaultSummary;